import type { IAddCartPayload, ICart } from '@/interfaces/cart.interface';
import type { IHttpResponse } from '@/interfaces/http.interface';

import api from '@/utils/axiosInstance';

import { baseURL } from '@/utils/constants';

export const getCart = async (sessionId?: string | null): Promise<IHttpResponse<ICart>> => {
  const res = await api.get(`${baseURL}/api/cart`, { params: { sessionId } });
  return res?.data;
};

export const addToCart = async (payload: IAddCartPayload): Promise<IHttpResponse<ICart>> => {
  const res = await api.post(`${baseURL}/api/cart/product/add`, payload);
  return res?.data;
};

export const removeFromCart = async (payload: IAddCartPayload): Promise<IHttpResponse<ICart>> => {
  const res = await api.post(`${baseURL}/api/cart/product/remove`, payload);
  return res?.data;
};

export const applyCouponOnCart = async (coupon: string, sessionId?: string | null): Promise<IHttpResponse<ICart>> => {
  const res = await api.post(`${baseURL}/api/cart/coupon/apply/${coupon}`, {}, { params: { sessionId } });
  return res?.data;
};

export const removeCouponFromCart = async (sessionId?: string | null): Promise<IHttpResponse<ICart>> => {
  const res = await api.delete(`${baseURL}/api/cart/coupon/remove`, { params: { sessionId } });
  return res?.data;
};
